export default __webpack_public_path__ + "static/media/h1-3.1a724fb2.jpg";